import { productIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const createPricingRule = {
  name: "createPricingRule" as const,

  input: z.object({
    name: z.string(),
    priority: z.number(),
    productIds: z.array(productIdFormat.schema),
    thresholds: z.array(
      z.object({
        quantity: z.number().int(),
        price: z.number().min(0),
        currency: z.string(),
      }),
    ),
  }),

  output: z.object({ success: z.boolean() }),
};
